import { Roles } from 'enums/roles'
import { StatiPratica } from 'enums/stati-pratica'

// I tipi di richieste supporto
export const listaTipiRichiesteSupporto = [
  {
    descrizione: 'Richiesta di supporto per ADVR in fase di onboarding',
    codice: 'onboarding',
    ruoli: [
      Roles.APPROVA_PRATICA_UTENTE_BASE.role,
      Roles.APPROVA_PRATICA_FIELD_ANALYST.role,
      Roles.APPROVATORE_MONITORAGGIO.role,
      Roles.RICHIESTA_ON_BOARDING.role,
      Roles.FIELD_ANALYST.role,
    ],
  },
  {
    descrizione: 'Richiesta di supporto per ADVR in fase di monitoraggio',
    codiceSelettore: 'monitoraggio',
    ruoli: [
      Roles.APPROVA_PRATICA_FIELD_ANALYST.role,
      Roles.RICHIESTA_MONITORAGGIO.role,
    ],
  },
]

// Sezione GIALLA ruoli e stati dove poter vedere bottoni di richiesta e risposta
export const listaStatiRichiestaSupportoSezionGialla = [
  StatiPratica.CHECK_OUT_OPERATORE.stato,
  StatiPratica.INFO_COMPLETE.stato,
  StatiPratica.IN_ATTESA_OPZIONALI.stato
]
export const listaRuoliRichiestaSupportoSezionGialla = [
  Roles.APPROVA_PRATICA_UTENTE_BASE.role,
  Roles.RICHIESTA_ON_BOARDING.role,
]

export const listaRuoliRispostaSupportoSezionGialla = [
  Roles.SUPPORTO_FUNZIONE_AML.role,
  Roles.SUPPORTO_AML_DESK.role,
]

// Sezione BLU ruoli e stati dove poter vedere bottoni di richiesta e risposta
export const listaStatiRichiestaSupportoSezioneBlu = [
  StatiPratica.DA_APPROVARE.stato,
]
export const listaRuoliRispostaSupportoSezioneBlu = [
  Roles.SUPPORTO_FUNZIONE_AML.role,
  Roles.SUPPORTO_AML_DESK.role,
]
